import { boardService } from '../../../services/board.service.js';
import { groupService } from '../../../services/group.service.js';
import { setBoard } from '../../board/reducers/board.reducer.js';
import { dispatchMultipleActions } from '../../dispatchHelper.js';
import { store } from '../../store.js';
import { addTask } from '../../task/reducers/task.reducer.js';
import {
  addGroup as createGroup,
  removeGroup,
  updateGroup as updateGroupReducer
} from '../reducers/group.reducer.js';

export async function addGroup(board, title = "New Group") {
  try {
    const accountId = store.getState().accounts.selectedAccount.accountId._id;

    if (!board) {
      throw new Error("Board not found");
    }

    // Criar novo grupo
    const newGroup = await groupService.create(accountId, {
      title,
      boardId: board._id
    });

    // Atualizar a lista de grupos do board
    const updatedBoard = {
      ...board,
      //groups: [...board.groups, newGroup._id]
      groups: [newGroup._id, ...board.groups]
    };

    // Salvar a atualização no backend
    await boardService.save(updatedBoard, accountId);

    // Atualizar Redux
    dispatchMultipleActions(
      setBoard({ board: updatedBoard }),
      //createGroup({ group: newGroup })
    );
    return { updatedBoard, newGroup };
  } catch (err) {
    console.error("Error adding group:", err);
    throw err;
  }
}

export async function updateGroup(group) {
  try {
    const accountId = store.getState().accounts.selectedAccount.accountId._id;

    if (!group || !group._id) {
      throw new Error("Invalid group data");
    }

    const updatedGroup = await groupService.update(accountId, group._id, group);

    dispatchMultipleActions(updateGroupReducer({ group: updatedGroup }));

    return updatedGroup;

  } catch (err) {
    console.error("Error updating group:", err);
    throw err;
  }
}

export async function duplicateGroup(group, board) {
  try {
    if (!group || !group._id) {
      throw new Error("Invalid group data");
    }

    // Chamar a API para duplicar o grupo
    const { group: newGroup, tasks: newTasks, board: updatedBoard } = await groupService.duplicateGroup(group._id);

    if (!newGroup || !newGroup._id) {
      throw new Error("Failed to duplicate group");
    }

    // Atualizar Redux: adicionar o novo grupo e as novas tasks
    dispatchMultipleActions(
      createGroup({ group: newGroup }), // Adiciona o novo grupo
      ...newTasks.map(task => addTask({ task })), // Adiciona as novas tasks
      setBoard({ board: updatedBoard }) // Atualiza o board com o novo grupo
    );

    return newGroup;
  } catch (err) {
    console.error("Error duplicating group:", err);
    throw err;
  }
}

// arrumar esta duplicando.
export async function archiveGroup(group) {
  try {
    const accountId = store.getState().accounts.selectedAccount.accountId._id;

    if (!group || !group._id) {
      throw new Error("Invalid group data");
    }

    // Atualiza o grupo no backend
    const updatedGroup = await groupService.update(accountId, group._id, {
      ...group,
      active: false,
    });

    // Atualiza a board removendo o ID do grupo arquivado
    const board = store.getState().board.board;
    const updatedBoard = {
      ...board,
      groups: board.groups.filter(id => id !== group._id)
    };

    // Salva a board no backend
    await boardService.save(updatedBoard, accountId);

    // Atualiza Redux
    dispatchMultipleActions(
      setBoard({ board: updatedBoard }),
      removeGroup({ groupId: group._id })
    );

    return updatedGroup;
  } catch (err) {
    console.error("Erro ao arquivar grupo:", err);
    throw err;
  }
}

export async function loadGroupsByBoard(boardId) {
  try {
    const groups = await groupService.getGroupsByBoardId(boardId);
    return groups;
  } catch (err) {
    console.error("Erro ao carregar grupos da board:", err);
    throw err;
  }
}

export async function getGroupById(groupId) {
  try {
    const groups = await groupService.getById(groupId);
    return groups;
  } catch (err) {
    console.error("Erro ao buscar grupo:", err);
    throw err;
  }
}


export async function loadBoardGroupsStatistics(boardId, groupIds, cmpIds, filter = {}) {
  try {
    return await groupService.getBoardGroupsStatistics(
      boardId,
      groupIds,
      cmpIds,
      filter
    );
  } catch (err) {
    console.error("Erro ao buscar estatísticas do grupo:", err);
    throw err;
  }
}